module.exports = __webpack_public_path__ + "static/img/nav_bg.f44f987f.png";